import { jsx } from "react/jsx-runtime";
import {
  createContext,
  useContext,
  useMemo,
  useState
} from "react";
const FormDevtoolsState = createContext(void 0);
const useFormDevtoolsState = () => {
  const context = useContext(FormDevtoolsState);
  if (context === void 0) {
    throw new Error("useFormDevtoolsConfig was used outside of its Provider");
  }
  return context;
};
const FormDevtoolsStateApi = createContext(void 0);
const useFormDevtoolsStateApi = () => {
  const context = useContext(FormDevtoolsStateApi);
  if (context === void 0) {
    throw new Error("useFormDevtoolsStateApi was used outside of its Provider");
  }
  return context;
};
const FormDevtoolsProvider = (props) => {
  const { children } = props;
  const [showControls, setShowControls] = useState("always");
  const [activeTab, setActiveTab] = useState(0);
  const [selectedNode, setSelectedNode] = useState("");
  const [treeHeight, setTreeHeight] = useState(0);
  const [anchor, setAnchor] = useState("right");
  const [open, setOpen] = useState(false);
  const config = useMemo(
    () => ({ showControls, activeTab, selectedNode, treeHeight, anchor, open }),
    [showControls, activeTab, selectedNode, treeHeight, anchor, open]
  );
  const configApi = useMemo(
    () => ({ setShowControls, setActiveTab, setSelectedNode, setTreeHeight, setAnchor, setOpen }),
    []
  );
  return /* @__PURE__ */ jsx(FormDevtoolsState.Provider, { value: config, children: /* @__PURE__ */ jsx(FormDevtoolsStateApi.Provider, { value: configApi, children }) });
};
export {
  FormDevtoolsProvider,
  useFormDevtoolsState,
  useFormDevtoolsStateApi
};
//# sourceMappingURL=formDevtoolsContext.js.map
